module.exports = ".question-icon{\r\n  cursor: pointer;\r\n  margin-right:6px;\r\n}\r\n\r\n.question-icon:hover{\r\n  opacity: 0.5;\r\n}\r\n\r\n.text-blue {\r\n  color: #006caa;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab1/awsop-lab1.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab1/awsop-lab1.component.css
// module chunks = main